import { ImagePicker } from './ImagePicker.js'

window.customElements.define('image-picker', ImagePicker)
